module.exports = __webpack_public_path__ + "static/media/mengmingluo.bebd085e.jpeg";